var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 20H2.14286C0.9375 20 0 19.0625 0 17.8571V2.14286C0 0.982143 0.9375 0 2.14286 0H6.42857C7.58929 0 8.57143 0.982143 8.57143 2.14286V17.8571C8.57143 19.0625 7.58929 20 6.42857 20Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 20H13.5714C12.3661 20 11.4286 19.0625 11.4286 17.8571V2.14286C11.4286 0.982143 12.3661 0 13.5714 0H17.8571C19.0179 0 20 0.982143 20 2.14286V17.8571C20 19.0625 19.0179 20 17.8571 20Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.ec72804e.svg";
export { ForwardRef as ReactComponent };